// API配置文件
export const getApiBaseUrl = () => {
  const hostname = window.location.hostname
  const protocol = window.location.protocol
  
  // 域名经 nginx 同源代理：请求已写 /api/...，baseURL 不能再带 /api（否则变成 /api/api/...）
  if (hostname.includes('nanyiqiutang.cn')) {
    return ''
  }
  
  // 如果是外部IP访问，使用外部IP的后端地址
  if (hostname === '121.36.205.70') {
    return `${protocol}//121.36.205.70:5005`
  }
  
  // 本地开发环境
  return `${protocol}//localhost:5005`
}

// 获取前台展示页面URL
export const getFrontendDisplayUrl = () => {
  const hostname = window.location.hostname
  
  // 如果是使用域名访问
  if (hostname.includes('nanyiqiutang.cn')) {
    return 'https://products.nanyiqiutang.cn'
  }
  
  // 如果是外部IP访问
  if (hostname === '121.36.205.70') {
    return 'http://121.36.205.70:8005'
  }
  
  // 本地开发环境
  return 'http://localhost:8005'
}

export const API_BASE_URL = getApiBaseUrl()
export const FRONTEND_DISPLAY_URL = getFrontendDisplayUrl() 